import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { fetchPerformanceCampaignCardsRequest, startPerformanceProgressRequest } from "../../../redux/actions/performanceActions";
import "../PerformanceStyles.css";
import PerformanceCampaignCard from "./PerformanceCampaignCard";
import { filterCampaignsWithDefaultFallback } from "./performanceUi";
import EntretienAnnuelModal from "../components/EntretienAnnuelModal";

export default function PerformanceCampaignList() {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { data, loading, error } = useSelector((state) => state.performance.campaignCards);
    const progressLoading = useSelector((state) => state.performance.progress.loading);
    const campaigns = filterCampaignsWithDefaultFallback(data);
    const [planificationProgressId, setPlanificationProgressId] = useState(null);

    useEffect(() => {
        dispatch(fetchPerformanceCampaignCardsRequest());
    }, [dispatch]);

    const openCampaign = (campaign) => {
        if (campaign.evaluationProgressId) {
            const readOnly = campaign.progressStatus === "COMPLETED" || campaign.progressStatus === "PENDING_VALIDATION";
            navigate(`/performance/evaluation/${campaign.evaluationProgressId}${readOnly ? "?mode=consultation" : ""}`);
            return;
        }
        dispatch(startPerformanceProgressRequest(campaign.campagneId, {
            onSuccess: (progress) => navigate(`/performance/evaluation/${progress.id}`),
        }));
    };

    const openPlanification = (campaign) => {
        if (campaign.evaluationProgressId) {
            setPlanificationProgressId(campaign.evaluationProgressId);
            return;
        }
        dispatch(startPerformanceProgressRequest(campaign.campagneId, {
            onSuccess: (progress) => setPlanificationProgressId(progress.id),
        }));
    };

    const openRevision = (campaign) => {
        if (campaign.evaluationProgressId && campaign.progressStatus !== "PENDING_VALIDATION" && campaign.progressStatus !== "COMPLETED") {
            navigate(`/performance/evaluation/${campaign.evaluationProgressId}?mode=revision`);
            return;
        }
    };

    return (
        <main className="perf-page">
            <header className="perf-header">
                <div>
                    <h1>Campagnes performance</h1>
                    <p>Vos campagnes d'entretien annuel.</p>
                </div>
            </header>

            {loading && <div className="perf-state">Chargement des campagnes...</div>}
            {error && <div className="perf-state perf-state--error">{error}</div>}
            {!loading && !error && campaigns.length === 0 && <div className="perf-state">Aucune campagne disponible.</div>}

            {!loading && !error && campaigns.length > 0 && (
                <section className="perf-campaign-grid">
                    {campaigns.map((campaign) => (
                        <PerformanceCampaignCard
                            key={campaign.campagneId}
                            campaign={campaign}
                            loading={progressLoading}
                            onOpen={openCampaign}
                            onPlanifier={openPlanification}
                            onReviser={openRevision}
                        />
                    ))}
                </section>
            )}
            <EntretienAnnuelModal
                open={Boolean(planificationProgressId)}
                progressId={planificationProgressId}
                title="Invitation entretien annuel"
                onClose={() => setPlanificationProgressId(null)}
            />
        </main>
    );
}
